import React, { useState } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  DatePicker,
  Select,
  message,
  Card,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import { load_cc_h } from "../api/apiCent90";
import AddBarcode from "../preview/AddBarcode";


// รอบส่งจดหมาย: วันที่ 12 และ 26 ของเดือน
const ROUND_DAY_OPTIONS = [
  { value: 12, label: "วันที่ 12" },
  { value: 26, label: "วันที่ 26" },
];

// แปลง caseType ("1" = ที่ดิน, "2" = รถ) ที่ส่งมาจาก parent
// ให้เป็นค่า product ที่ตรงกับข้อมูลจาก backend ("land" / "car")
const mapCaseTypeToProduct = (caseType) => {
  if (String(caseType) === "1") return "land";
  if (String(caseType) === "2") return "car";
  return undefined;
};

// caseType: "1" = ที่ดิน, "2" = รถ (ส่งมาจาก parent เพื่อกรองอัตโนมัติ ไม่ต้องให้ผู้ใช้เลือกเอง)
function ModalAccept({ dataA, selectedRowKeys, caseType }) {
  const [dataMainEMS, setDataMainEMS] = useState([]);
  const [dateEMS, setDateEMS] = useState("");
  const [form] = Form.useForm();
  const [dataMainEMSBackup, setDataMainEMSBackup] = useState([]);

  const productType = mapCaseTypeToProduct(caseType);

  console.log("data1245", dataA);

  const onFinish = (values) => {
    if (!values.monthEms || !values.dayEms) {
      message.error("กรุณาเลือกปี/เดือน และรอบวันที่ก่อนค้นหา");
      return;
    }
    // รวมปี/เดือน + วันที่ (12 / 26) เป็นวันที่รอบ
    const dateEms1 = dayjs(values.monthEms)
      .date(values.dayEms)
      .format("YYYY-MM-DDT00:00:00+07:00");
    setDateEMS(dateEms1);
    loadDataEMS(dateEms1);
  };

  const emsClose = () => {
    form.resetFields();
    setDataMainEMS([]);
    setDataMainEMSBackup([]);
    setDateEMS("");
  };

  const filterByCaseType = (dataSource) => {
    if (!productType) return dataSource;
    return dataSource.filter((item) => item.product === productType);
  };

  const loadDataEMS = async (dateEms1) => {
    try {
      const res = await axios.post(
        load_cc_h,
        { date: dateEms1, company: "3" },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
          },
        },
      );
      // กันกรณี mainData เป็น undefined (ไม่มีข้อมูล) ไม่ให้ .filter พัง
      const dataB = Array.isArray(res.data?.mainData) ? res.data.mainData : [];
      const filtered = filterByCaseType(dataB);
      setDataMainEMSBackup(dataB);
      setDataMainEMS(filtered);
      if (filtered.length === 0) message.info("ไม่พบข้อมูลในรอบที่เลือก");
    } catch (err) {
      console.log(err);
      // ค้นหาวันที่ไม่มีข้อมูล/เกิด error → เคลียร์ตาราง ไม่ให้ค้างข้อมูลรอบเก่า
      setDataMainEMSBackup([]);
      setDataMainEMS([]);
      message.info("ไม่พบข้อมูลในรอบที่เลือก");
    }
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 1300,
        margin: "0 auto",
        marginTop: 0,
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      <Card
        bordered={false}
        style={{
          borderRadius: 12,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          marginBottom: 2,
          marginTop: 0,
          width: "100%",
        }}
        bodyStyle={{ padding: "8px 20px 12px" }}
      >
        <Form
          layout="vertical"
          name="basic"
          onFinish={onFinish}
          form={form}
          autoComplete="off"
        >
          <Row gutter={[16, 8]} align="bottom" style={{ margin: 0, marginTop: 4 }}>
            <Col xs={24} sm={12} md={6}>
              <Form.Item
                name="monthEms"
                label="ปี/เดือน"
                initialValue={dayjs()}
                rules={[{ required: true, message: "กรุณาเลือกปี/เดือน" }]}
                style={{ marginBottom: 0 }}
              >
                <DatePicker
                  picker="month"
                  format="MM/YYYY"
                  style={{ width: "100%" }}
                  placeholder="เลือกปี/เดือน"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item
                name="dayEms"
                label="รอบวันที่"
                // ค่าเริ่มต้น: รอบที่ใกล้วันนี้ที่สุด (ถึงวันที่ 12 = รอบ 12, หลังจากนั้น = รอบ 26)
                initialValue={dayjs().date() <= 12 ? 12 : 26}
                rules={[{ required: true, message: "กรุณาเลือกรอบวันที่" }]}
                style={{ marginBottom: 0 }}
              >
                <Select options={ROUND_DAY_OPTIONS} placeholder="เลือก 12 หรือ 26" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  icon={<SearchOutlined />}
                  block
                >
                  ค้นหาสัญญา
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>

      <Card
        bordered={false}
        style={{
          borderRadius: 12,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          width: "100%",
        }}
        bodyStyle={{ padding: "12px 16px", overflowX: "auto" }}
      >
        <AddBarcode
          data={dataMainEMS}
          date={dateEMS}
          onBack={emsClose}
          refreshCalendar={() => loadDataEMS(dateEMS)}
          roundDate={dateEMS}
          // ที่ดิน (land) = สัญญา 1 (lsfhp) เสมอ: ล็อกประเภท ไม่ต้องให้เลือก
          lockedSchema={productType === "land" ? "lsfhp" : null}
        />
      </Card>
    </div>
  );
}
export default ModalAccept;